<script setup lang="ts">
import arrowDown from "@/assets/image/icons/arrow-down.svg";
import { $t } from "@/i18n";
import { useDefaultStore } from "@/store";

const store = useDefaultStore();
const route = useRoute();
const isServicesOpen = ref(false);

const emit = defineEmits(["click-menu-item", "close"]);
</script>

<template>
  <div
    class="bg-text-dark text-text-light hide-scrollbar fixed inset-0 top-[70px] z-[100] flex h-[calc(100vh-var(--spacing-header)+1)] flex-col gap-[30px] overflow-y-auto p-5 font-sans text-xl font-bold"
  >
    <!-- Menu -->
    <div class="flex flex-col items-center gap-y-10 text-center text-[var(--color-text)]">
      <!-- Main pages -->
      <router-link
        :to="{ name: 'HomePage' }"
        class="mb-2 cursor-pointer uppercase transition select-none hover:opacity-80 hover:brightness-125"
        :class="{ 'text-primary': route.name === 'HomePage' }"
        @click="emit('click-menu-item')"
      >
        <div>{{ $t("app.nav.home") }}</div>
      </router-link>

      <!-- Services parent -->
      <div class="mb-2">
        <div class="flex justify-center gap-2" @click="isServicesOpen = !isServicesOpen">
          <div
            class="cursor-pointer uppercase transition select-none hover:opacity-80 hover:brightness-125"
            :class="{ 'text-primary': store.services.map((s) => s.name).includes(route.name as string) }"
          >
            {{ $t("app.nav.services.label") }}
          </div>

          <img
            :src="arrowDown"
            alt="Toggle services"
            class="cursor-pointer transition-transform duration-300"
            :class="{ 'rotate-180': isServicesOpen }"
          />
        </div>

        <transition name="fade">
          <div v-if="isServicesOpen" class="mt-2 flex flex-col items-center gap-y-6 text-xl font-normal uppercase">
            <router-link
              v-for="service in store.services"
              :key="service.name"
              :to="{ name: service.name }"
              :class="['block px-4 py-2 hover:opacity-80', route.name === service.name ? 'text-primary' : 'text-text-light']"
              @click="
                emit('click-menu-item');
                isServicesOpen = false;
              "
            >
              {{ service.label }}
            </router-link>
          </div>
        </transition>
      </div>

      <router-link
        :to="{ name: 'ContactPage' }"
        class="mb-2 cursor-pointer uppercase transition select-none hover:opacity-80 hover:brightness-125"
        :class="{ 'text-primary': route.name === 'ContactPage' }"
        @click="emit('click-menu-item')"
      >
        <div>{{ $t("app.nav.contact") }}</div>
      </router-link>
    </div>

    <!-- Lang switcher -->
    <lang-switcher class="mx-auto w-fit" :selected="store.langSelected" @change="store.langSelected = $event" />
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
